import { CAR } from './car.config';
import { MOBILE_HOME } from './mobile-home.config';
import { MOTORCYCLE } from './motorcycle.config';
import { SMALL_ELECTRIC_VEHICLE } from './small-electric-vehicle.config';
import { BOAT } from './boat.config';
import { TRAILER_HOME } from './trailer-home.config';
import { TRAILER } from './trailer.config';
import { MOPED } from './moped.config';
import { SNOWMOBILE } from './snowmobile.config';
import { TRACTOR } from './tractor.config';
import { VETERAN_CAR } from './veteran-car.config';
import { HOUSE } from './house.config';
import { CONTENTS } from './contents.config';
import { VACATION_HOME } from './vacation-home.config';
import { VALUABLES } from './valuables.confg';
import { ANIMAL } from './animal.config';
import { TRAVEL } from './travel.config';
import { ACCIDENT } from './accident.config';
import { CHILD } from './child.config';
import { CHILDREN } from './children.config';
import { ANSVARFORSIKRING } from './ansvarsforsikring.config';
import { DENTAL } from './dental.config';
import { RENT_HOUSE } from './rent-house.config';
import { HOUSE_ROT } from './house-rot.config';
import { VACATION_HOME_ABROAD } from './vacation-home-abroad.config';
import { ILLNESS } from './illness.config';
import { CRITICAL_ILLNESS } from './critical-illness.config';
import { INCOME_ACCIDENT } from './income-accident.config';
import { INCOME } from './income.config';
import { POLICY } from './policy.config';
import { PENSION } from './pension.config';
import { RENTAL } from './rental.config';
import { LIFE } from './life.config';
import { HEALTH } from './health.config';
import { NATURSKADE } from './naturskade.config';
import { GREEDY_FEE } from './greedy-fee.config';
import { DEBT } from './debt.config';
import { UNREGISTERED_MOTO } from './unregistered-moto.config';
import { FEE } from './fee.config';
import { OFFER } from './offer.config';

export const PRODUCTS_MAP_TTFINANS = {
  CAR,
  MOBILE_HOME,
  MOTORCYCLE,
  SMALL_ELECTRIC_VEHICLE,
  BOAT,
  TRAILER_HOME,
  TRAILER,
  MOPED,
  SNOWMOBILE,
  TRACTOR,
  VETERAN_CAR,
  HOUSE,
  CONTENTS,
  VACATION_HOME,
  VALUABLES,
  ANIMAL,
  TRAVEL,
  ACCIDENT,
  CHILD,
  CHILDREN,
  ANSVARFORSIKRING,
  DENTAL,
  RENT_HOUSE,
  HOUSE_ROT,
  VACATION_HOME_ABROAD,
  ILLNESS,
  CRITICAL_ILLNESS,
  INCOME_ACCIDENT,
  INCOME,
  POLICY,
  PENSION,
  RENTAL,
  LIFE,
  HEALTH,
  NATURSKADE,
  GREEDY_FEE,
  DEBT,
  UNREGISTERED_MOTO,
  FEE,
  OFFER,
  UNDEFINED: {
    nickname: 'PRODUCTS.UNDEFINED.shortname',
    isHidden: true
  }
};
